
const Model = (initialState, actions = {}) => {
  const listeners = [];
  const model = {
    initialized: false,
    state: initialState || {},
  };

  model.actions = Object.keys(actions).reduce((modifiers, key) => {
    const action = actions[key];
    modifiers[key] = (...args) => {
      args.unshift(model);
      return action.apply(null, args);
    };
    return modifiers;
  }, {});

  model.actions.setState = (newState) => {
    if (newState !== model.state) {
      model.state = newState;

      listeners.forEach(listener => {
        listener(model.state);
      });
    }
  };

  const subscribe = (listener) => {
    listeners.push(listener);
    if (!model.intialized) {
      model.intialized = true;
      if (typeof model.actions.init === 'function') {
        model.actions.init();
      }
    }

    return () => {
      unsubscribe(listener);
    };
  };

  const unsubscribe = (listener) => {
    const index = listeners.indexOf(listener);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  };
  
  return {
    get state() {
      return model.state;
    },
    get actions() {
      return model.actions;
    },
    subscribe,
    unsubscribe,
  };
};

export default Model;
